import Modal from './Modal';
import ConfirmDialog from './ConfirmDialog';
import PrimaryModal from './PrimaryModal';
import ConfirmModal from './confirmModal';

export default Modal;
export {
  Modal,
  ConfirmDialog,
  PrimaryModal,
  ConfirmModal,
};

